export default "__VITE_ASSET__457f1aee__"